import request from '@/utils/request'

/** -------药学院--------- */
export function collegePharmacylist(data) {
  return request({
    url: '/product/collegePharmacy/list',
    method: 'post',
    data
  }).then(res => res.data.result || [])
}

// 获取药帮忙的几个地址
export function getECRedirectUrl(data) {
  return request({
    url: '/user/coupons/getECRedirectUrl',
    method: 'post',
    data
  }).then(res => res.data.result || [])
}

// 获取优惠券信息
export function getMyCouponsList(data) {
  return request({
    url: '/user/coupons/getMyCouponsList',
    method: 'post',
    data
  }).then(res => res.data || [])
}

// 获取首页优惠券信息
export function getHomeCoupons(data) {
  return request({
    url: '/user/coupons/getMyStandardsCoupons',
    method: 'post',
    data
  }).then(res => res.data || [])
}

// 核对药帮忙密码
export function checkYBMBinding(data) {
  return request({
    url: '/user/drugstore/checkYBMBinding',
    method: 'post',
    data
  }).then(res => res.data || [])
}

// 绑定
export function ybmOrganSignBind(data) {
  return request({
    url: '/user/drugstore/ybmOrganSignBinding',
    method: 'post',
    data
  }).then(res => res.data || [])
}

// 判断是否绑定了药帮忙
export function ybmIsBind(data) {
  return request({
    url: '/user/drugstore/checkYBMBindByOrganSign',
    method: 'post',
    data
  }).then(res => res.data || [])
}

// 进度条
export function getProgressBar(data) {
  return request({
    url: '/user/coupons/getMyStandardsProgressBar',
    method: 'post',
    data
  }).then(res => res.data || [])
}

// 领券接口
export function getCoupons(data) {
  return request({
    url: '/user/coupons/doSendECCoupons',
    method: 'post',
    data
  }).then(res => res.data || [])
}

// 首页 生意参谋模块的显示隐藏
export function getProvinceName(data) {
  return request({
    url: '/index/getProvinceName',
    method: 'post',
    data: {
      featureType: 'newHome',
      ...data
    }
  }).then(res => res.data || [])
}

// 采购推荐列表
export function purProList(data) {
  return request({
    url: '/product/recommend/purchaseProduct',
    method: 'post',
    data
  }).then(res => res.data || [])
}

// 生意参谋列表页
export function listBusinessStaffStandardClassifyTop(data) {
  return request({
    url: '/index/listBusinessStaffStandardClassifyTop',
    method: 'post',
    data: {
      featureType: 'newHome',
      ...data
    }
  }).then(res => res.data || [])
}

// 生意参谋反馈页面
export function saveBusinessStaffOpinion(data) {
  return request({
    url: '/index/saveBusinessStaffOpinion',
    method: 'post',
    data: {
      featureType: 'newHome',
      ...data
    }
  }).then(res => res.data || [])
}

// 判断是否绑定药帮忙
export function checkYBMUser(data) {
  return request({
    url: '/user/drugstore/checkYBMUser',
    method: 'post',
    data
  }).then(res => res.data || [])
}
// 获取药帮忙账号密码
export function getYBmPassWord(data) {
  return request({
    url: '/user/drugstore/queryYbmInfoByOrganSign',
    method: 'post',
    data
  }).then(res => res.data || [])
}

// 获取下载地址
export function getDownloadList(data) {
  return request({
    url: '/promotion/smart/getUrlConfig',
    method: 'post',
    data
  })
}